import React, { useState, useEffect } from "react";
import { Container, Row, Col, Stack, Button, Placeholder, ListGroup, Badge } from "react-bootstrap";
import Swal from 'sweetalert2'
import { TODIS_BTN_SECUNDARY } from "../../../components/Buttons";
import { BsArrowRight, BsCalendarMinusFill } from "react-icons/bs";
import { FaDatabase } from "react-icons/fa";
import dateFormat from "dateformat";
import { BsArrowLeft, BsCloudSlashFill } from "react-icons/bs";
import "../../DataCollection/style.css";
import "./styles.css";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { TaskService } from "../../../HttpService/TaskService";
import { RequestService } from "../../../HttpService/RequestService";
import { HiCheck, HiX } from "react-icons/hi";
import { IoMdCheckboxOutline } from "react-icons/io";
import { activateStatusRed } from "../../DataCollection/form.jsx";

  
const workflowMessage = {
    1 : {
        1: {
            msg: "Data Collection pending",
            icon: "",
            style: { backgroundColor: "#F4D35A", lineHeight: "47px"}
        },
        2: {
            msg: "Data Collection in progress",
            icon: "",
            style: { backgroundColor: "#3db73d", lineHeight: "47px"}
        },
        3: {
            msg: "Data Collection is completed",
            icon: "",
            style: { backgroundColor: "#3fdf3d", lineHeight: "47px"}
        }
    },
    2: {
        1: {
            msg: "Data Collection validation pending",
            icon: "",
            style: { backgroundColor: "#F4D35A", lineHeight: "47px"}
        },
        2: {
            msg: "Data Collection validation in progress",
            icon: "",
            style: { backgroundColor: "#3db73d", lineHeight: "47px"}
        },
        3: {
            msg: "Data Collection is validated by the Regional Coordinator",
            icon: "",
            style: { backgroundColor: "#3fdf3d", lineHeight: "47px"}
        },
        4: {
            msg: "Data Collection is rejected by the Regional Coordinator",
            icon: "",
            style: { backgroundColor: "#df3d3d", lineHeight: "47px"}
        },
    },
    3: {
        1: {
            msg: "Data Collection final validation pending",
            icon: "",
            style: { backgroundColor: "#F4D35A", lineHeight: "47px"}
        },
        2: {
            msg: "Data Collection final validation in progress",
            icon: "",
            style: { backgroundColor: "#3db73d", lineHeight: "47px"}
        },
        3: {
            msg: "Data Collection is accepted by the Administrator",
            icon: "",
            style: { backgroundColor: "#3fdf3d", lineHeight: "47px"}
        },
        4: {
            msg: "Data Collection is rejected by the Administrator",
            icon: "",
            style: { backgroundColor: "#df3d3d", lineHeight: "47px"}
        }
    }
}

// const monthNames = ["January", "February", "March", "April", "May", "June",
//   "July", "August", "September", "October", "November", "December"
// ];

// const weekNames = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"]

const requestStatus = {
    "NEW": "New",
    "DATA_COLLECTION_IN_PROGRESS": "Data Collection In Progress",
    "DATA_COLLECTION_DONE": "Data Collection Done",
    "READY_TO_VALIDATE": "Ready To Validate",
    "VALIDATION_IN_PROGRESS": "Validation In Progress",
    "VALIDATION_DONE": "Validation Done",
    "READY_TO_APPROVE": "Ready To Approve",
    "APPROVAL_IN_PROGRESS": "Approval In Progress",
    "ACCEPTED": "Accepted",
    "VALIDATION_FAILED": "Validation Failed",
    "REJECTED": "Rejected",
  };

const Request = ({permissions, backUrl, type}) => {

    function getProjectTitle(transportType, regionalPartner, projectType) {
        const transportTypeTranslations = {
          'Roads': 'Road',
          'Railways': 'Railway',
          'Inland waterways': 'Inland Waterway',
          'Airports': 'Airport',
          'Railways Border Crossings': 'Railway Border Crossing',
          'Roads Border crossing': 'Road Border Crossing',
          'Seaports': 'Seaport',
          'Inland waterway ports': 'Inland Waterway Port'
        };
      
        if(transportType === 'Roads' || transportType === 'Railways' || transportType === 'Inland waterways'){
            if (projectType === 'TEN-T Projects') {
            return `${getSingularTransportType(transportType)} Project in ${regionalPartner}`;
            } else if (projectType === 'TEN-T Network performance monitoring') {
            return `${getSingularTransportType(transportType)} Section in ${regionalPartner}`;
            }
        }else if (projectType === 'EU Acquis'){
            return `${projectType} in ${regionalPartner}`;
        }else{
            return `${getSingularTransportType(transportType)} in ${regionalPartner}`
        }
      
        function getSingularTransportType(type) {
          return transportTypeTranslations[type] || type;
        }
    }

    const navigate = useNavigate();
    // const {state} = useLocation();

    //load task details by its ID
    let baseUrl = (window.location).href;
    let id = baseUrl.substring(baseUrl.lastIndexOf('/') + 1);
    const [taskId, setTaskId] = useState(id)
    const [task, setTask] = useState({})
    const [history,setHistory] = useState({});
    const [taskNotFound, setTaskNotFound] = useState(false)

    const statusClass = (statusId) => {
        if(statusId == 0 || statusId == 3 || statusId == 6)
            return "#F4D35A";
        else if(statusId == 1 || statusId == 4)
            return "#004494";
        else if(statusId == 7){
            return "#ff0000"
        }
        else if(statusId == 2 || statusId == 5 || statusId == 8)
            return "#3db73d"
    }

    useEffect(() => {
        (async () => {
            let url;
            if (!isNaN(taskId)){
                if(permissions.some(item => item.id == 2) && type == "request")
                    // url = "dashboard/task-detail/";
                    url = "workflow/request/";
                else
                    url = "workflow/task/test/";
                
                let res = await new TaskService(url + taskId).getTaskById();
                let response;
                if(type != "request") 
                    response = await new RequestService("workflow/request/history/" + res.requestId).get();
                else 
                    response = await new RequestService("workflow/request/history/" + taskId).get();
                console.log("response from request history is", response);
                if (response) 
                    setHistory(response);
                if(res)                   
                    setTask(res);
                else
                    setTaskNotFound(true);
            } else 
                setTaskNotFound(true);

        })();
    }, []);

    const formatDate = (date) => {
        return new Date(date).toLocaleString('en-us',{ day: "numeric",month:'short', year:'numeric' , hour: "2-digit"});
    }

    const deleteRequest = async () => {

        try {
            Swal.fire({
                title: 'Are you sure?',
                text: "You won't be able to revert this!",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, delete it!'
            }).then(async(result) => {
                if (result.isConfirmed) {
                    let res = await new RequestService("workflow/request/" + taskId).deleteRequests();
                
                    //console.log("Hello2" + res);
        
                    if(res.status == 200){
                        Swal.fire({
                            position: 'center',
                            icon: 'success',
                            title: 'Deleted!',
                            text: 'The request has been deleted.',
                            showConfirmButton: true
                        })
                        navigate(backUrl);
                    } else {
                        Swal.close();
                        Swal.fire({
                            position: 'center',
                            icon: 'error',
                            title: 'Error',
                            text: 'An unexpected error occurred while creating the update request.',
                            showConfirmButton: true
                        });

                        console.log("error in delete Request", res);
                    }
                }
            })
        } catch (error) {
            console.log("error in delete Request", error);
        }
    }

    return (
        <>
        <Col xxl={8} xl={8} lg={12} md={12} sm={12}>
            <Container fluid className="todis-form-wrapper p-4" style={{height:'95%'}}>
            {JSON.stringify(task) !== '{}' && !taskNotFound ?
                <div>
                    <Row className="todis-form-action-panel pb-3">
                        <Col lg={2} style={{ width: 'auto' }}>
                            <TODIS_BTN_SECUNDARY variant="primary" icon={BsArrowLeft} onclick={() => navigate(backUrl)} />
                        </Col>
                        {/* <Col lg={10} style={{ alignSelf: 'center' }}>
                            <h4 className="todis-header">{type == "request" ? task.transportType : task.requestDetailsDTO.transportType} in {type == "request" ? task.regionalPartnar : task.requestDetailsDTO.regionalPartnar}</h4>
                        </Col> */}

                        <Col lg={10} style={{ alignSelf: 'center' }}>
                            <h4 className="todis-header">
                               {type === "request"
                                ? getProjectTitle(task.transportType, task.regionalPartnar, task.projectType)
                                : getProjectTitle(task.requestDetailsDTO.transportType, task.requestDetailsDTO.regionalPartnar, task.requestDetailsDTO.projectType)}
                            </h4>
                        </Col>
                               {/*  {type === "request"
                                ? getProjectTitle(task.transportType, task.regionalPartner, task.projectType)
                                : getProjectTitle(task.requestDetailsDTO.transportType, task.requestDetailsDTO.regionalPartner, task.requestDetailsDTO.projectType)}
                            </h4> */}
                    </Row>
                    <Row className="p-3">
                        <Row>
                            <Col lg={6} className="task-att py-3"> {type == "task" ? "Task" : "Request"} ID: <span className="task-att-value">{type == "task" ? task.id : taskId}</span></Col>
                            <Col lg={6} className="task-att py-3" style={{ textAlign: "right" }}> Created at: <span className="task-att-value ">{dateFormat(history.response[0].createdAt, "dd-mm-yyyy")}</span></Col>
                            <Col lg={12} className="py-3">
                                <label className="task-att-value ">Description</label>
                                <p className="pt-3 task-att-gray-value">{type == "request" ? task.tentCategory : task.requestDetailsDTO.description}</p>
                            </Col>

                            <Col lg={4} className="task-att-value py-3 pr-5"> TENT Category <div className="task-att-gray-value mt-2">{type == "request" ? task.tentCategory : task.requestDetailsDTO.tentCategory}</div></Col>
                            <Col lg={4} className="task-att-value py-3 px-5"> Road Type <div className="task-att-gray-value mt-2">{type == "request" ? task.transportType : task.requestDetailsDTO.transportType}</div></Col>
                            <Col lg={4} className="task-att-value py-3 px-5"> Collection Type <div className="task-att-gray-value mt-2">{type == "request" ? task.projectType : task.requestDetailsDTO.projectType}</div></Col>
                            <Col lg={4} className="task-att-value py-3 pr-5"> Route ID <div className="task-att-gray-value mt-2">{type == "request" ? task.routeId : task.requestDetailsDTO.routeId}</div></Col>
                            <Col lg={4} className="task-att-value py-3 px-5"> Start Node <div className="task-att-gray-value mt-2">{type == "request" ? task.startNode : task.requestDetailsDTO.startNode}</div></Col>
                            <Col lg={4} className="task-att-value py-3 px-5"> End Node <div className="task-att-gray-value mt-2">{type == "request" ? task.endNode : task.requestDetailsDTO.endNode}</div></Col>

                            <Col lg={4} className="task-att-value py-3 pr-5 task-bordered"> Task Type
                                <div className="task-att-gray-value mt-4 d-flex flex-row align-items-center"><div className="avatar-white me-2"><FaDatabase style={{ fontSize: "30px", color: "#004494" }} /></div> {type == "request" ? task.name : task.requestDetailsDTO.name}</div>
                            </Col>
                            <Col lg={4} className="task-att-value py-3 px-5 task-bordered"> Assigned To
                                <div className="task-att-gray-value mt-4 d-flex flex-row align-items-center"><div className="avatar me-2">JD </div> {type == "request" ? task.assignedTo : task.requestDetailsDTO.assignedTo}</div>
                            </Col>
                            <Col lg={4} className="task-att-value py-3 px-5"> Status
                                <div className="task-att-gray-value mt-4 d-flex flex-row align-items-center"><div className={`status me-2 ${statusClass(1)}`}> </div> {type == "request" ? requestStatus[task.status] : requestStatus[task.requestDetailsDTO.status]}</div>
                            </Col>
                        </Row>

                    </Row>
                    <Row xs="auto justify-content-end mt-5">
                        <Col>
                        {
                            permissions.some(item => item.id == 2) && type == "request" ?
                                <Button 
                                    variant="danger" 
                                    className={task.status != "NEW" ? "todis-outline-action-delete-btn invisible" : "todis-outline-action-delete-btn"} 
                                    type="submit" 
                                    onClick={() => {
                                        // Mostrar Swal de carga
                                        const loadingSwalTimeout = setTimeout(() => {
                                            Swal.fire({
                                                title: 'Processing...',
                                                text: 'Please wait while we delete the request.',
                                                allowOutsideClick: false,
                                                //showCancelButton: true,
                                                //cancelButtonText: 'Close',
                                                didOpen: () => {
                                                    Swal.showLoading();
                                                }
                                            });
                                        }, 50);
                                        deleteRequest();
                                        clearTimeout(loadingSwalTimeout);
                                        Swal.close();
                                    }} 
                                    disabled={task.status != "NEW"}
                                >
                                    DELETE REQUEST 
                                    <BsArrowRight className="mx-3" fontSize={18}/> 
                                </Button>
                            :
                            (permissions.some(item => item.id == 5))  ?
                            <Button 
                                variant="primary" 
                                className="todis-action-btn" 
                                type="submit" 
                                onClick={() => {
                                    // Mostrar Swal de carga
                                    const loadingSwalTimeout = setTimeout(() => {
                                        Swal.fire({
                                            title: 'Processing...',
                                            text: 'Please wait while we navigate to the data collection page.',
                                            allowOutsideClick: false,
                                            //showCancelButton: true,
                                            //cancelButtonText: 'Close',
                                            didOpen: () => {
                                                Swal.showLoading();
                                            }
                                        });
                                    }, 50);
                                    navigate("/TODIS-APP/DataCollection/" + task.requestDetailsDTO.formTypeName, { state: task });
                                    clearTimeout(loadingSwalTimeout);
                                    Swal.close();
                                }}
                            >
                                VALIDATE DATA COLLECTION 
                                <BsArrowRight className="mx-3" fontSize={18}/> 
                            </Button>
                            : permissions.some(item => item.id != 5) ?
                                <Button 
                                    variant="primary" 
                                    className="todis-action-btn" 
                                    type="submit" 
                                    onClick={() => {
                                        // Mostrar Swal de carga
                                        const loadingSwalTimeout = setTimeout(() => {
                                            Swal.fire({
                                                title: 'Processing...',
                                                text: 'Please wait while we navigate to the data collection page.',
                                                allowOutsideClick: false,
                                                //showCancelButton: true,
                                                //cancelButtonText: 'Close',
                                                didOpen: () => {
                                                    Swal.showLoading();
                                                }
                                            });
                                        }, 50);
                                        navigate("/TODIS-APP/DataCollection/" + task.requestDetailsDTO.formTypeName, { state: task });
                                        clearTimeout(loadingSwalTimeout);
                                        Swal.close();
                                    }}
                                >
                                    START DATA COLLECTION 
                                    <BsArrowRight className="mx-3" fontSize={18}/> 
                                </Button>
                            : null
                        }
                                {/* <Button variant="primary" className="todis-action-btn" type="submit" onClick={() => navigate("/TODIS-APP/DataCollection/"+task.requestDetailsDTO.formTypeName, {state:task})}>
                                            START DATA COLLECTION 
                                            <BsArrowRight className="mx-3" fontSize={18}/> 
                                </Button> */}
                            </Col>
                        </Row>
                    </div> :
                    // loading placeholder section 
                    taskNotFound ? <div className="h-100 d-flex justify-content-center align-items-center"> <div style={{ textAlign: "center" }}>
                        <BsCloudSlashFill fontSize={100} color="#000000" />
                        <h3 className="">Task Not found </h3>
                    </div></div> :
                        <div>
                            <Row className="todis-form-action-panel pb-3">
                                <Col lg={2} style={{ width: 'auto' }}>
                                    {
                                        backUrl && 
                                        <TODIS_BTN_SECUNDARY variant="primary" icon={BsArrowLeft} onclick={() => navigate(backUrl)}/>
                                    }
                                </Col>
                                <Col lg={10} style={{ alignSelf: 'center' }}>
                                    {/* <h4 className="todis-header">Data Collection Request in Serbia</h4> */}
                                    <Placeholder as="h4" animation="glow"><Placeholder xs={4} size="lg" /></Placeholder>
                                </Col>
                            </Row>
                            <Row className="p-3">
                                <Row>
                                    <Col lg={6} className="task-att py-3"> <Placeholder as="h5" animation="glow"><Placeholder xs={2} size="md" /></Placeholder></Col>
                                    <Col lg={6} className="task-att py-3" style={{ textAlign: "right" }}> <Placeholder as="h5" animation="glow"><Placeholder xs={2} size="md" /></Placeholder></Col>
                                    <Col lg={12} className="py-3">
                                        {/* <label className="task-att-value ">Description</label> */}
                                        <Placeholder as="p" animation="glow">
                                            <Placeholder xs={7} size="lg" /> <Placeholder xs={4} size="lg" /> <Placeholder xs={4} size="lg" />{' '}
                                            <Placeholder xs={6} size="lg" /> <Placeholder xs={8} size="lg" />
                                        </Placeholder>
                                    </Col>

                                    <Col lg={4} className="task-att-value py-3 pr-5"> <Placeholder as="h5" animation="glow"><Placeholder xs={6} size="lg" /></Placeholder></Col>
                                    <Col lg={4} className="task-att-value py-3 px-5"> <Placeholder as="h5" animation="glow"><Placeholder xs={6} size="lg" /></Placeholder></Col>
                                    <Col lg={4} className="task-att-value py-3 px-5"> <Placeholder as="h5" animation="glow"><Placeholder xs={6} size="lg" /></Placeholder></Col>
                                    <Col lg={4} className="task-att-value py-3 pr-5"> <Placeholder as="h5" animation="glow"><Placeholder xs={6} size="lg" /></Placeholder></Col>
                                    <Col lg={4} className="task-att-value py-3 px-5"> <Placeholder as="h5" animation="glow"><Placeholder xs={6} size="lg" /></Placeholder></Col>
                                    <Col lg={4} className="task-att-value py-3 px-5"> <Placeholder as="h5" animation="glow"><Placeholder xs={6} size="lg" /></Placeholder></Col>

                                    <Col lg={4} className="task-att-value py-3 pr-5 task-bordered"> <Placeholder as="h5" animation="glow"><Placeholder xs={6} size="lg" /></Placeholder>
                                    </Col>
                                    <Col lg={4} className="task-att-value py-3 px-5 task-bordered"> <Placeholder as="h5" animation="glow"><Placeholder xs={6} size="lg" /></Placeholder>
                                    </Col>
                                    <Col lg={4} className="task-att-value py-3 px-5"> <Placeholder as="h5" animation="glow"><Placeholder xs={6} size="lg" /></Placeholder>
                                    </Col>
                                </Row>

                            </Row>
                            <Row xs="auto justify-content-end mt-5">
                                <Col lg={3}>
                                    
                                {
                                    permissions.some(item => item.id == 2) && type == "request" ?
                                        <Placeholder.Button variant="danger" xs={12} />
                                    : permissions.some(item => item.id == 3 || item.id == 5 || item.id == 6) ?
                                        <Placeholder.Button variant="warning" xs={12} />
                                    : null
                                }
                                </Col>
                            </Row>
                        </div>
                }
            </Container>
        </Col>
        <Col>
        {JSON.stringify(history) !== '{}' && history.response.length > 0 ?
            <Container fluid className="todis-form-wrapper p-4" style={{height:'95%'}}>
                <Row className="todis-form-action-panel pb-3">
                    <Col lg={12} style={{ alignSelf: 'center' }}>
                        <h4 className="todis-header"><BsCalendarMinusFill className="me-3" />Request History</h4>
                    </Col>
                </Row>
                <Row className="pt-4">
                <ListGroup as="ol">
                        <ListGroup.Item
                            as="li"
                            className="py-0 border-0"
                        >
                            <Row>
                                <Col lg={2} className="task-att-value" style={{alignSelf: "flex-end"}}>
                                    <div className={`statusTask ${statusClass(1)}`} style={{backgroundColor: "#e3f2fd"}}> </div>
                                </Col>
                                <Col lg={10} className="task-att-value ps-3">
                                    <Row>
                                        <Col lg={12}>
                                            <div className="d-flex flex-row align-items-center" >Request has been created </div>
                                        </Col>
                                        <Col lg={7} style={{alignSelf: "center"}}>
                                            <div className="d-flex flex-row align-items-center" style={{margin: "0px", color: "#a5a5a5",fontWeight: "500"}}> {formatDate(history.requestDetailsDTO.createdAt)}</div>
                                        </Col>
                                        <Col lg={5}>
                                            <div className="task-att-gray-value  d-flex flex-row align-items-center" ><div className="avatarHistory me-2"> </div> {history.requestDetailsDTO.assignedBy}</div>
                                        </Col>
                                    </Row>
                                </Col>
                                <Col lg={2} style={{paddingLeft: "34px"}}>
                                    <div style={{backgroundColor: "#e3f2fd", border: "1px solid #e3f2fd", height: "100%", width: "5px"}}></div>
                                </Col>
                                <Col lg={10} className="task-att-value ps-0 pt-2 ps-3">
                                    <div className="d-flex flex-row align-items-center pb-2" style={{margin: "0px", color: "#a5a5a5",fontWeight: "500", minHeight: "30px"}}></div>
                                </Col>
                            </Row>
                        </ListGroup.Item>

                        {history.response.map((task) => (
                            <ListGroup.Item
                            as="li"
                            className="d-flex justify-content-between align-items-start py-0 border-0"
                        >
                            <Row>
                                <Col lg={2} className="task-att-value" style={{alignSelf: "flex-end"}}>
                                    <div className={`statusTask ${statusClass(1)}`} style={workflowMessage[task.roleId][task.statusId].style}>{task.statusId == 4 ? <HiX size={28}/> : <HiCheck size={28}/> }</div>
                                </Col>
                                <Col lg={10} className="task-att-value ps-3">
                                    <Row>
                                        <Col lg={12}>
                                            <div className="d-flex flex-row align-items-center" >{workflowMessage[task.roleId][task.statusId].msg} </div>{activateStatusRed(task)}
                                        </Col>
                                        <Col lg={7} style={{alignSelf: "center"}}>
                                            <div className="d-flex flex-row align-items-center" style={{margin: "0px", color: "#a5a5a5",fontWeight: "500"}}>{dateFormat(task.createdAt)} </div>
                                        </Col>
                                        <Col lg={5}>
                                            <div className="task-att-gray-value  d-flex flex-row align-items-center" ><div className="avatarHistory me-2"> </div> {task.assignedTo}</div>
                                        </Col>
                                    </Row>
                                </Col>
                                <Col lg={2} style={{paddingLeft: "34px"}}>
                                    <div style={{backgroundColor: "#e3f2fd", border: "1px solid #e3f2fd", height: "100%", width: "5px"}}></div>
                                </Col>
                                <Col lg={10} className="task-att-value ps-0 pt-2 ps-2">
                                    <div className="d-flex flex-row align-items-center pb-2" style={{margin: "0px", color: "#a5a5a5",fontWeight: "500", minHeight: "30px"}}>{task.comment} </div>
                                </Col>
                            </Row>
                        </ListGroup.Item>
                        ))}

                        </ListGroup>
                    {/* <ListGroup as="ol">
                        <ListGroup.Item
                            as="li"
                            className="py-0 border-0"
                        >
                            <Row>
                                <Col lg={2} className="task-att-value" style={{alignSelf: "flex-end"}}>
                                    <div className={`statusTask ${statusClass(1)}`} style={{backgroundColor: "#e3f2fd"}}> </div>
                                </Col>
                                <Col lg={10} className="task-att-value ps-3">
                                    <Row style={{fontSize: "14px"}}>
                                        <Col lg={12}>
                                            <div className="d-flex flex-row align-items-center" style={{fontSize: "18px"}}>Request has been created </div>
                                        </Col>
                                        <Col lg={7} style={{alignSelf: "center"}}>
                                            <div className="d-flex flex-row align-items-center" style={{margin: "0px", color: "#a5a5a5",fontWeight: "500"}}>Monday 18 Apr 2:00 PM </div>
                                        </Col>
                                        <Col lg={5}>
                                            <div className="task-att-gray-value  d-flex flex-row align-items-center" style={{fontSize: "14px"}}><div className="avatarHistory me-2">JD </div> {"John Doe"}</div>
                                        </Col>
                                    </Row>
                                </Col>
                                <Col lg={2} style={{paddingLeft: "34px"}}>
                                    <div style={{backgroundColor: "#e3f2fd", border: "1px solid #e3f2fd", height: "100%", width: "5px"}}></div>
                                </Col>
                                <Col lg={10} className="task-att-value ps-0 pt-2 ps-3">
                                    <div className="d-flex flex-row align-items-center pb-2" style={{margin: "0px", color: "#a5a5a5", fontSize: "14px",fontWeight: "500", minHeight: "30px"}}></div>
                                </Col>
                            </Row>
                        </ListGroup.Item>
                        <ListGroup.Item
                            as="li"
                            className="d-flex justify-content-between align-items-start py-0 border-0"
                        >
                            <Row>
                                <Col lg={2} className="task-att-value" style={{alignSelf: "flex-end"}}>
                                    <div className={`statusTask ${statusClass(1)}`} style={{backgroundColor: "#3fdf3d", lineHeight: "47px"}}><HiCheck size={28}/> </div>
                                </Col>
                                <Col lg={10} className="task-att-value ps-2">
                                    <Row style={{fontSize: "14px"}}>
                                        <Col lg={12}>
                                            <div className="d-flex flex-row align-items-center" style={{fontSize: "18px"}}>Data Collection is completed </div>
                                        </Col>
                                        <Col lg={7} style={{alignSelf: "center"}}>
                                            <div className="d-flex flex-row align-items-center" style={{margin: "0px", color: "#a5a5a5",fontWeight: "500"}}>Monday 18 Apr 2:00 PM </div>
                                        </Col>
                                        <Col lg={5}>
                                            <div className="task-att-gray-value  d-flex flex-row align-items-center" style={{fontSize: "14px"}}><div className="avatarHistory me-2">JD </div> {"John Doe"}</div>
                                        </Col>
                                    </Row>
                                </Col>
                                <Col lg={2} style={{paddingLeft: "34px"}}>
                                    <div style={{backgroundColor: "#e3f2fd", border: "1px solid #e3f2fd", height: "100%", width: "5px"}}></div>
                                </Col>
                                <Col lg={10} className="task-att-value ps-0 pt-2 ps-2">
                                    <div className="d-flex flex-row align-items-center pb-2" style={{margin: "0px", color: "#a5a5a5", fontSize: "14px",fontWeight: "500", minHeight: "30px"}}>Bellow is a summary of the Svilaj, including percentage complete, budget used so far, and open issues to resolve </div>
                                </Col>
                            </Row>
                        </ListGroup.Item>
                        <ListGroup.Item
                            as="li"
                            className="d-flex justify-content-between align-items-start py-0 border-0"
                        >
                            <Row>
                                <Col lg={2} className="task-att-value" style={{alignSelf: "flex-end"}}>
                                    <div className={`statusTask ${statusClass(1)}`} style={{backgroundColor: "#df3d3d", lineHeight: "46px"}}><HiX size={28}/> </div>
                                </Col>
                                <Col lg={10} className="task-att-value ps-2">
                                    <Row style={{fontSize: "14px"}}>
                                        <Col lg={12}>
                                            <div className="d-flex flex-row align-items-center" style={{fontSize: "18px"}}>Data Collection has been rejected </div>
                                        </Col>
                                        <Col lg={7} style={{alignSelf: "center"}}>
                                            <div className="d-flex flex-row align-items-center" style={{margin: "0px", color: "#a5a5a5",fontWeight: "500"}}>Monday 18 Apr 2:00 PM </div>
                                        </Col>
                                        <Col lg={5}>
                                            <div className="task-att-gray-value  d-flex flex-row align-items-center" style={{fontSize: "14px"}}><div className="avatarHistory me-2">JD </div> {"John Doe"}</div>
                                        </Col>
                                    </Row>
                                </Col>
                                <Col lg={2} style={{paddingLeft: "34px"}}>
                                    <div style={{backgroundColor: "#e3f2fd", border: "1px solid #e3f2fd", height: "100%", width: "5px"}}></div>
                                </Col>
                                <Col lg={10} className="task-att-value ps-0 pt-2 ps-2">
                                    <div className="d-flex flex-row align-items-center pb-2" style={{margin: "0px", color: "#a5a5a5", fontSize: "14px",fontWeight: "500", minHeight: "30px"}}>Bellow is a summary of the Svilaj, including percentage complete, budget used so far, and open issues to resolve </div>
                                </Col>
                            </Row>
                        </ListGroup.Item>
                        <ListGroup.Item
                            as="li"
                            className="d-flex justify-content-between align-items-start py-0 border-0"
                        >
                            <Row>
                                <Col lg={2} className="task-att-value" style={{alignSelf: "flex-end"}}>
                                    <div className={`statusTask ${statusClass(1)}`} style={{backgroundColor: "#fac21b", lineHeight: "46px"}}><IoMdCheckboxOutline size={28}/> </div>
                                </Col>
                                <Col lg={10} className="task-att-value ps-2">
                                    <Row style={{fontSize: "14px"}}>
                                        <Col lg={12}>
                                            <div className="d-flex flex-row align-items-center" style={{fontSize: "18px"}}>Data Collection has been rejected </div>
                                        </Col>
                                        <Col lg={7} style={{alignSelf: "center"}}>
                                            <div className="d-flex flex-row align-items-center" style={{margin: "0px", color: "#a5a5a5",fontWeight: "500"}}>Monday 18 Apr 2:00 PM </div>
                                        </Col>
                                        <Col lg={5}>
                                            <div className="task-att-gray-value  d-flex flex-row align-items-center" style={{fontSize: "14px"}}><div className="avatarHistory me-2">JD </div> {"John Doe"}</div>
                                        </Col>
                                    </Row>
                                </Col>
                                <Col lg={2} style={{paddingLeft: "34px"}}>
                                    <div style={{backgroundColor: "#e3f2fd", border: "1px solid #e3f2fd", height: "100%", width: "5px"}}></div>
                                </Col>
                                <Col lg={10} className="task-att-value ps-0 pt-2 ps-2">
                                    <div className="d-flex flex-row align-items-center pb-2" style={{margin: "0px", color: "#a5a5a5", fontSize: "14px",fontWeight: "500", minHeight: "30px"}}>Bellow is a summary of the Svilaj, including percentage complete, budget used so far, and open issues to resolve </div>
                                </Col>
                            </Row>
                        </ListGroup.Item>
                    </ListGroup> */}
                </Row>
            </Container> : 
                <Container fluid className="todis-form-wrapper p-4">
                <Row className="todis-form-action-panel pb-3">
                    <Col lg={12} style={{ alignSelf: 'center' }}>
                        <h4 className="todis-header"><BsCalendarMinusFill className="me-3" />Request History</h4>
                    </Col>
                </Row>
                <Row className="pt-4">
                <ListGroup as="ol">
                        <ListGroup.Item
                            as="li"
                            className="py-0 border-0"
                        >
                            <Row>
                                <Col lg={2} className="task-att-value" style={{alignSelf: "flex-end"}}>
                                    <div className={`statusTask ${statusClass(1)}`} style={{backgroundColor: "#e3f2fd"}}> </div>
                                </Col>
                                <Col lg={10} className="task-att-value ps-3">
                                    <Row style={{fontSize: "14px"}}>
                                        <Col lg={12}>
                                            <Placeholder as="h5" animation="glow"><Placeholder xs={12} size="lg" /></Placeholder> 
                                        </Col>
                                        <Col lg={7} style={{alignSelf: "center"}}>
                                            <Placeholder as="h5" animation="glow"><Placeholder xs={12} size="lg" /></Placeholder> 
                                        </Col>
                                        <Col lg={5}>
                                            <div className="task-att-gray-value  d-flex flex-row align-items-center" style={{fontSize: "14px"}}><Placeholder as="h5" animation="glow"><Placeholder xs={12} size="lg" /></Placeholder></div>
                                        </Col>
                                    </Row>
                                </Col>
                                <Col lg={2} style={{paddingLeft: "34px"}}>
                                    <div style={{backgroundColor: "#e3f2fd", border: "1px solid #e3f2fd", height: "100%", width: "5px"}}></div>
                                </Col>
                                <Col lg={10} className="task-att-value ps-0 pt-2 ps-3">
                                    <div className="d-flex flex-row align-items-center pb-2" style={{margin: "0px", color: "#a5a5a5", fontSize: "14px",fontWeight: "500", minHeight: "30px"}}></div>
                                </Col>
                            </Row>
                        </ListGroup.Item>

                        <ListGroup.Item
                            as="li"
                            className="py-0 border-0"
                        >
                            <Row>
                                <Col lg={2} className="task-att-value" style={{alignSelf: "flex-end"}}>
                                    <div className={`statusTask ${statusClass(1)}`} style={{backgroundColor: "#e3f2fd"}}> </div>
                                </Col>
                                <Col lg={10} className="task-att-value ps-3">
                                    <Row style={{fontSize: "14px"}}>
                                        <Col lg={12}>
                                            <Placeholder as="h5" animation="glow"><Placeholder xs={12} size="lg" /></Placeholder> 
                                        </Col>
                                        <Col lg={7} style={{alignSelf: "center"}}>
                                            <Placeholder as="h5" animation="glow"><Placeholder xs={12} size="lg" /></Placeholder> 
                                        </Col>
                                        <Col lg={5}>
                                            <div className="task-att-gray-value  d-flex flex-row align-items-center" style={{fontSize: "14px"}}><Placeholder as="h5" animation="glow"><Placeholder xs={12} size="lg" /></Placeholder></div>
                                        </Col>
                                    </Row>
                                </Col>
                                <Col lg={2} style={{paddingLeft: "34px"}}>
                                    <div style={{backgroundColor: "#e3f2fd", border: "1px solid #e3f2fd", height: "100%", width: "5px"}}></div>
                                </Col>
                                <Col lg={10} className="task-att-value ps-0 pt-2 ps-3">
                                    <div className="d-flex flex-row align-items-center pb-2" style={{margin: "0px", color: "#a5a5a5", fontSize: "14px",fontWeight: "500", minHeight: "30px"}}></div>
                                </Col>
                            </Row>
                        </ListGroup.Item>

                        <ListGroup.Item
                            as="li"
                            className="py-0 border-0"
                        >
                            <Row>
                                <Col lg={2} className="task-att-value" style={{alignSelf: "flex-end"}}>
                                    <div className={`statusTask ${statusClass(1)}`} style={{backgroundColor: "#e3f2fd"}}> </div>
                                </Col>
                                <Col lg={10} className="task-att-value ps-3">
                                    <Row style={{fontSize: "14px"}}>
                                        <Col lg={12}>
                                            <Placeholder as="h5" animation="glow"><Placeholder xs={12} size="lg" /></Placeholder> 
                                        </Col>
                                        <Col lg={7} style={{alignSelf: "center"}}>
                                            <Placeholder as="h5" animation="glow"><Placeholder xs={12} size="lg" /></Placeholder> 
                                        </Col>
                                        <Col lg={5}>
                                            <div className="task-att-gray-value  d-flex flex-row align-items-center" style={{fontSize: "14px"}}><Placeholder as="h5" animation="glow"><Placeholder xs={12} size="lg" /></Placeholder></div>
                                        </Col>
                                    </Row>
                                </Col>
                                <Col lg={2} style={{paddingLeft: "34px"}}>
                                    <div style={{backgroundColor: "#e3f2fd", border: "1px solid #e3f2fd", height: "100%", width: "5px"}}></div>
                                </Col>
                                <Col lg={10} className="task-att-value ps-0 pt-2 ps-3">
                                    <div className="d-flex flex-row align-items-center pb-2" style={{margin: "0px", color: "#a5a5a5", fontSize: "14px",fontWeight: "500", minHeight: "30px"}}></div>
                                </Col>
                            </Row>
                        </ListGroup.Item>

                        <ListGroup.Item
                            as="li"
                            className="py-0 border-0"
                        >
                            <Row>
                                <Col lg={2} className="task-att-value" style={{alignSelf: "flex-end"}}>
                                    <div className={`statusTask ${statusClass(1)}`} style={{backgroundColor: "#e3f2fd"}}> </div>
                                </Col>
                                <Col lg={10} className="task-att-value ps-3">
                                    <Row style={{fontSize: "14px"}}>
                                        <Col lg={12}>
                                            <Placeholder as="h5" animation="glow"><Placeholder xs={12} size="lg" /></Placeholder> 
                                        </Col>
                                        <Col lg={7} style={{alignSelf: "center"}}>
                                            <Placeholder as="h5" animation="glow"><Placeholder xs={12} size="lg" /></Placeholder> 
                                        </Col>
                                        <Col lg={5}>
                                            <div className="task-att-gray-value  d-flex flex-row align-items-center" style={{fontSize: "14px"}}><Placeholder as="h5" animation="glow"><Placeholder xs={12} size="lg" /></Placeholder></div>
                                        </Col>
                                    </Row>
                                </Col>
                                <Col lg={2} style={{paddingLeft: "34px"}}>
                                    <div style={{backgroundColor: "#e3f2fd", border: "1px solid #e3f2fd", height: "100%", width: "5px"}}></div>
                                </Col>
                                <Col lg={10} className="task-att-value ps-0 pt-2 ps-3">
                                    <div className="d-flex flex-row align-items-center pb-2" style={{margin: "0px", color: "#a5a5a5", fontSize: "14px",fontWeight: "500", minHeight: "30px"}}></div>
                                </Col>
                            </Row>
                        </ListGroup.Item>
                        </ListGroup>
                </Row>
            </Container> 
            }
        </Col>
        </>
    );
}

export default Request;